module.exports = __webpack_public_path__ + "static/media/Ex3-S2-AV-6.c49c6ef3.PNG";